var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88939 4.92068C3.03214 4.76469 3.22573 4.67706 3.42759 4.67706C3.62945 4.67706 3.82304 4.76469 3.96579 4.92068L7.99508 9.32487L12.0244 4.92068C12.0946 4.84121 12.1786 4.77782 12.2715 4.73421C12.3643 4.6906 12.4642 4.66765 12.5653 4.66669C12.6664 4.66573 12.7666 4.68678 12.8602 4.72862C12.9537 4.77046 13.0387 4.83224 13.1102 4.91037C13.1817 4.98849 13.2382 5.0814 13.2765 5.18365C13.3148 5.28591 13.334 5.39548 13.3331 5.50596C13.3323 5.61645 13.3113 5.72563 13.2714 5.82715C13.2315 5.92867 13.1735 6.02048 13.1008 6.09724L8.53328 11.0897C8.39053 11.2457 8.19693 11.3333 7.99508 11.3333C7.79322 11.3333 7.59963 11.2457 7.45688 11.0897L2.88939 6.09724C2.74668 5.9412 2.6665 5.7296 2.6665 5.50896C2.6665 5.28832 2.74668 5.07672 2.88939 4.92068Z",
    fill: "#1D314C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBold);
export default __webpack_public_path__ + "static/media/arrow-down-bold.f7bc6f3b7ebded7bbd4aaf799c2d1eff.svg";
export { ForwardRef as ReactComponent };